import { Link } from 'react-router-dom';

interface CTAProps {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonTo?: string;
  onClick?: () => void;
}

export function FinalCTA({ title, subtitle, buttonText, buttonTo, onClick }: CTAProps) {
  return (
    <section className="hero-glow py-20 md:py-28">
      <div className="mx-auto max-w-[800px] px-6 text-center">
        <h2 className="text-balance text-3xl font-bold text-white md:text-4xl">{title}</h2>
        <p className="mt-4 text-lg text-white/75">{subtitle}</p>
        <div className="mt-8">
          {buttonTo ? (
            <Link
              to={buttonTo}
              className="btn-primary inline-flex items-center justify-center rounded-[10px] px-8 py-3.5 text-base font-semibold"
            >
              {buttonText}
            </Link>
          ) : (
            <button
              onClick={onClick}
              className="btn-primary inline-flex items-center justify-center rounded-[10px] px-8 py-3.5 text-base font-semibold"
            >
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default FinalCTA;
